import Navbar from "./Navbar";
import Footer from "./Footer";
import CampusAmbassadorDetails from "./Campus_Ambassador/CampusAmbassador_Details";
import DataShowcase from "./Campus_Ambassador/Data";
import CampusAmbassadorForm from "./Campus_Ambassador/CampusAmbassadorForm";
import './Css/campus_ambassador.css';

function CampusAmbassador() {
  return (
    <div>
      <Navbar />
      <CampusAmbassadorDetails />
      <DataShowcase />
      <CampusAmbassadorForm />
      <Footer />
    </div>
  );
}

export default CampusAmbassador;